module.exports = __webpack_public_path__ + "static/media/light_blue-theme.6428a5b9.png";